module.exports = __webpack_public_path__ + "fonts/fa-brands-400.91a23e8.woff2";